/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ViewLineups_query$ref = any;
export type ViewLineupsPaginationQueryVariables = {|
  count?: ?number,
  cursor?: ?string,
  lineupSetId: string,
|};
export type ViewLineupsPaginationQueryResponse = {|
  +$fragmentRefs: ViewLineups_query$ref
|};
export type ViewLineupsPaginationQuery = {|
  variables: ViewLineupsPaginationQueryVariables,
  response: ViewLineupsPaginationQueryResponse,
|};
*/


/*
query ViewLineupsPaginationQuery(
  $count: Int = 9
  $cursor: String
  $lineupSetId: ID!
) {
  ...ViewLineups_query_4TL5Z
}

fragment ViewLineups_query_4TL5Z on Query {
  lineupsForLineupSet(lineupSetId: $lineupSetId, first: $count, after: $cursor) {
    edges {
      node {
        id
        totalSalary
        totalProjOwnership
        totalProjPoints
        isValid
        validityLevel
        locked
        players {
          id
          lineupRosterSlot {
            id
            rosterSlot {
              id
              name
            }
          }
          player {
            slatePlayer {
              id
              position
              salary
              player {
                name
                shortenedName
                team {
                  abbreviation
                  id
                }
                id
              }
              suffix
              gupPercProj
              projPoints
            }
            id
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": 9,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lineupSetId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "lineupSetId",
  "variableName": "lineupSetId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewLineupsPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "ViewLineups_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewLineupsPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "GreenMachineLineupTypeConnection",
        "kind": "LinkedField",
        "name": "lineupsForLineupSet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GreenMachineLineupTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GreenMachineLineupType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalSalary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalProjOwnership",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalProjPoints",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isValid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "validityLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "locked",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GreenMachineLineupPlayerType",
                    "kind": "LinkedField",
                    "name": "players",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LineupRosterSlotType",
                        "kind": "LinkedField",
                        "name": "lineupRosterSlot",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RosterSlotType",
                            "kind": "LinkedField",
                            "name": "rosterSlot",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GreenMachineSessionPlayerType",
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SlatePlayerType",
                            "kind": "LinkedField",
                            "name": "slatePlayer",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "position",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "salary",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PlayerType",
                                "kind": "LinkedField",
                                "name": "player",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "shortenedName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamType",
                                    "kind": "LinkedField",
                                    "name": "team",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "abbreviation",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "suffix",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "gupPercProj",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "projPoints",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "lineupSetId"
        ],
        "handle": "connection",
        "key": "ViewLineups_lineupsForLineupSet",
        "kind": "LinkedHandle",
        "name": "lineupsForLineupSet"
      }
    ]
  },
  "params": {
    "cacheID": "9f8e35ab43ef9b57b39a1e1e686cbc9c",
    "id": null,
    "metadata": {},
    "name": "ViewLineupsPaginationQuery",
    "operationKind": "query",
    "text": "query ViewLineupsPaginationQuery(\n  $count: Int = 9\n  $cursor: String\n  $lineupSetId: ID!\n) {\n  ...ViewLineups_query_4TL5Z\n}\n\nfragment ViewLineups_query_4TL5Z on Query {\n  lineupsForLineupSet(lineupSetId: $lineupSetId, first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        totalSalary\n        totalProjOwnership\n        totalProjPoints\n        isValid\n        validityLevel\n        locked\n        players {\n          id\n          lineupRosterSlot {\n            id\n            rosterSlot {\n              id\n              name\n            }\n          }\n          player {\n            slatePlayer {\n              id\n              position\n              salary\n              player {\n                name\n                shortenedName\n                team {\n                  abbreviation\n                  id\n                }\n                id\n              }\n              suffix\n              gupPercProj\n              projPoints\n            }\n            id\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dc0b7685e54be731c1b33c1106a3d1fe';

module.exports = node;
